
import React from 'react';
import SectionTransition from '@/components/ui/SectionTransition';
import { motion } from 'framer-motion';

interface SectionHeaderProps {
  title: string;
  subtitle: string;
  emoji: string;
  titleColor?: string;
}

const SectionHeader = ({ 
  title, 
  subtitle, 
  emoji,
  titleColor = "text-white" 
}: SectionHeaderProps) => {
  return (
    <SectionTransition type="fade" className="text-center mb-3 md:mb-6">
      <motion.div 
        className="text-xl md:text-2xl mb-2"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        {emoji}
      </motion.div>
      
      <h2 className={`text-2xl md:text-3xl lg:text-4xl font-bold mb-2 ${titleColor}`}>
        {title.split(' ').map((word, i) => (
          <span key={i}>
            {i > 0 && ' '}
            {i === title.split(' ').length - 1 ? (
              <span className="text-[#FF6B6B]">{word}</span>
            ) : word}
          </span>
        ))}
      </h2>
      
      <div className="flex justify-center">
        <motion.div
          className="h-0.5 w-8 md:w-16 bg-[#FF6B6B] rounded-full"
          initial={{ width: 0 }}
          animate={{ width: '3rem' }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        />
      </div>
      
      <motion.p
        className="mt-3 text-sm md:text-base lg:text-lg max-w-2xl mx-auto text-white font-medium px-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.1 }}
      >
        {subtitle}
      </motion.p>
    </SectionTransition>
  );
};

export default SectionHeader;
